import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customNumber'
})
export class CustomNumberPipe implements PipeTransform {

  transform(value: string): any {
    if (!value) { return null; }

    value = this.removeComma(value);
    return this.addComma(value);
  }

  private addComma(num: string): string {

    return num.length > 3
      ? num.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : num;

  }

  private removeComma(num: string): string {

    return (num.length > 3 && num.includes(','))
      ? num.split(',').join('')
      : num;

  }

}
